import * as React from "react"

export const LockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.75 17.583c-.37 0-.684-.13-.944-.392a1.296 1.296 0 01-.39-.947V8.757c0-.37.132-.686.393-.948a1.29 1.29 0 01.947-.392h.66v-2c0-.995.35-1.84 1.048-2.538.698-.697 1.545-1.046 2.54-1.046.997 0 1.842.35 2.537 1.046.695.697 1.042 1.543 1.042 2.538v2h.66c.37 0 .686.13.948.392.261.262.392.578.392.948v7.487c0 .37-.13.685-.393.947a1.292 1.292 0 01-.947.392H5.75zm.006-1.083h8.488a.25.25 0 00.184-.072.25.25 0 00.072-.184V8.757a.25.25 0 00-.072-.185.25.25 0 00-.184-.072H5.756a.25.25 0 00-.184.072.25.25 0 00-.072.185v7.487a.25.25 0 00.072.184.25.25 0 00.184.072zm4.248-2.708c.36 0 .665-.126.914-.378.25-.252.374-.558.374-.918s-.126-.665-.378-.914a1.257 1.257 0 00-.918-.373c-.36 0-.665.125-.914.377a1.257 1.257 0 00-.374.918c0 .36.126.665.378.914.252.25.558.374.918.374zM7.5 7.417h5v-2c0-.695-.243-1.285-.73-1.771a2.41 2.41 0 00-1.77-.73 2.41 2.41 0 00-1.77.73 2.41 2.41 0 00-.73 1.77v2z"
    />
  </svg>
)
